import type { TextareaFormattingType } from './textarea-markdown-util';
import { TextareaReplacementUtil } from './textarea-replacement-util';

/**
 * Normalisation applied before a value is persisted, per convention. Legacy
 * collapses the paragraph breaks its import expanded, so the stored shape is
 * unchanged; modern instead normalises pasted bullet syntax the way the previous
 * editor did on save.
 *
 * The previous editor also stripped four or more leading spaces here, because
 * markdown reads them as a code block. Lexical does not — indented text imports
 * as an ordinary paragraph — and stripping them flattens the indentation that
 * nested list items export with, so it is deliberately left out.
 *
 * Keyed rather than branched so each formatter keeps a stable identity, which
 * the value plugin depends on.
 */
export const TextareaValueFormatters: Record<
  TextareaFormattingType,
  (markdown: string) => string | null
> = {
  legacy: (markdown: string) =>
    markdown
      ? new TextareaReplacementUtil(markdown)
          .replaceEmptyBulletListItem()
          .replacesTwoNewLinesWithOne()
          .getText()
      : null,
  modern: (markdown: string) =>
    markdown
      ? new TextareaReplacementUtil(markdown)
          .replaceEmptyBulletListItem()
          .replaceUncommonBulletFormatToCommon()
          .getText()
      : null,
};
